import { ODataHeader, ODataString, ODataDate } from "pbas-vue-components";

import { translate2 } from "../trans2";

function getHeaders(cols) {
  console.log(cols, cols.indexOf("Last Name") > -1);
  let headers = [
    new ODataHeader({
      title: "Id",
      type: new ODataString("Id"),
      sortable: true,
      visible: false,
      searchable: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
  ];
  if (cols.indexOf("Last Name") > -1) {
    headers.push(
      new ODataHeader({
        title: "headers.members_management.Last Name",
        type: new ODataString("CurrentMember/LastName"),
        sortable: true,
        visible: true,
        searchable: true,
      })
    );
  }
  if (cols.indexOf("First Name") > -1) {
    headers.push(
      new ODataHeader({
        title: "headers.members_management.First Name",
        type: new ODataString("CurrentMember/FirstName"),
        sortable: true,
        visible: true,
        searchable: true,
      })
    );
  }
  if (cols.indexOf("Membership Id") > -1) {
    headers.push(
      new ODataHeader({
        title: "headers.members_management.Membership Id",
        type: new ODataString("MemberIdentification/PensionMembershipId"),
        sortable: true,
        visible: true,
        searchable: true,
      })
    );
  }
  if (cols.indexOf("SIN") > -1) {
    headers.push(
      new ODataHeader({
        title: "headers.members_management.SIN",
        type: new ODataString("MemberIdentification/SIN"),
        sortable: true,
        visible: true,
        searchable: true,
      })
    );
  }
  if (cols.indexOf("Certificate") > -1) {
    headers.push(
      new ODataHeader({
        title: "headers.members_management.Certificate",
        type: new ODataString("MemberIdentification/Certificate"),
        sortable: true,
        visible: true,
        searchable: true,
      })
    );
  }
  if (cols.indexOf("Date Of Birth") > -1) {
    headers.push(
      new ODataHeader({
        title: "headers.members_management.Date Of Birth",
        type: new ODataDate("CurrentMember/DateOfBirth"),
        sortable: true,
        visible: true,
        searchable: true,
      })
    );
  }
  if (cols.indexOf("City") > 0) {
    headers.push(
      new ODataHeader({
        title: "headers.members_management.City",
        type: new ODataString("CurrentContactInformation/Address/City"),
        sortable: true,
        visible: true,
        searchable: true,
      })
    );
  }
  if (cols.indexOf("Employer") > -1) {
    headers.push(
      new ODataHeader({
        title: "headers.members_management.Employer",
        type: new ODataString(
          "CurrentEmploymentInformation/Employer/Current/Translations[]/Name",
          {
            getString: (item) => {
              if (
                item.CurrentEmploymentInformation.Employer === null ||
                item.CurrentEmploymentInformation.Employer === undefined ||
                item.CurrentEmploymentInformation.Employer.Current === null ||
                item.CurrentEmploymentInformation.Employer.Current === undefined
              ) {
                return "";
              }
              return translate2(
                item.CurrentEmploymentInformation.Employer.Current,
                "Name"
              );
            },
          }
        ),
        sortable: true,
        visible: true,
        searchable: true,
      })
    );
    headers.push(
      new ODataHeader({
        type: new ODataString(
          "CurrentEmploymentInformation/Employer/Current/Translations[]/LanguageCode"
        ),
        visible: false,
        searchable: false,
      })
    );
  }
  if (cols.indexOf("Store") > -1) {
    headers.push(
      new ODataHeader({
        title: "headers.members_management.Store",
        type: new ODataString(
          "CurrentEmploymentInformation/Store/Current/Translations[]/Name",
          {
            getString: (item) => {
              if (
                item.CurrentEmploymentInformation.Store === null ||
                item.CurrentEmploymentInformation.Store === undefined ||
                item.CurrentEmploymentInformation.Store.Current === null ||
                item.CurrentEmploymentInformation.Store.Current === undefined
              ) {
                return "";
              }
              return translate2(
                item.CurrentEmploymentInformation.Store.Current,
                "Name"
              );
            },
          }
        ),
        sortable: true,
        visible: true,
        searchable: true,
      })
    );
    headers.push(
      new ODataHeader({
        type: new ODataString(
          "CurrentEmploymentInformation/Store/Current/Translations[]/LanguageCode"
        ),
        visible: false,
      })
    );
  }
  if (cols.indexOf("Phone Number") > -1) {
    headers.push(
      new ODataHeader({
        title: "headers.members_management.Phone Number",
        type: new ODataString("CurrentContactInformation/PhoneNumber"),
        sortable: true,
        visible: true,
        searchable: true,
      })
    );
  }
  if (cols.indexOf("Email") > -1) {
    headers.push(
      new ODataHeader({
        title: "headers.members_management.Email",
        type: new ODataString("Email"),
        sortable: true,
        visible: true,
        searchable: true,
      })
    );
  }
  return headers;
}

export default getHeaders;
// "First Name",
//               "Last Name",
//               "SIN",
//               "Membership Id",
//               "Certificate",
//               "Date Of Birth",
//               "City",
//               "Employer",
//               "Store",
//               "Phone Number",
//               "EmployerTranslationsCode",
//               "EmployerTranslations",
//               "StoreTranslationsCode",
//               "StoreTranslations",
//               "Email",
